<template>
  <pt-life-experience-pavilion-invoice class="pt-life-experience-pavilion-invoice__withData"
  @reservationExport="reservationExport" :exportLoading="exportLoading"
  ></pt-life-experience-pavilion-invoice>
</template>

<script>
import PtLifeExperiencePavilionInvoice from './index'
export default {
  name: 'pt-life-experience-pavilion-invoice__withData',
  components: {
    'pt-life-experience-pavilion-invoice': PtLifeExperiencePavilionInvoice
  },
  data () {
    return {
      exportLoading: false
    }
  },
  methods: {
    reservationExport (params) {
      const {
        reservationDate,
        searchKey,
        reservationInvoiceStatus
      } = params

      const reservationStartTime = reservationDate ? reservationDate.reservationStartTime : ''
      const reservationEndTime = reservationDate ? reservationDate.reservationEndTime : ''

      const data = {
        pageable: {
          page: this.page,
          size: this.pageSize
        },
        reservationStartTime,
        reservationEndTime,
        searchKey,
        reservationInvoiceStatus
      }
      data.allInvoice = !reservationInvoiceStatus || null
      this.exportLoading = true
      this.$store.dispatch('reservationExport', data).then(res => {
        this.exportLoading = false
        this.$message.success('数据准备中，完成导出后我们会将数据保存在“导出历史”中，您稍后下载即可')
      }).catch(err => {
        this.exportLoading = false
        this.$message.error(err || '导出生命体验馆发票失败')
      })
    }
  }
}
</script>
